import { Injectable } from "@nestjs/common";
import { DeheadingPeelingEntity } from "../deheading-peeling-entity";
import { DeheadingPeelingDTO } from "./deheading-peeling.dto";
@Injectable()
export class DeheadingPeelingAdapter{
    public convertDtoToEntity(deheadingpeelingDTO:DeheadingPeelingDTO, isUpdate: boolean = false):DeheadingPeelingEntity{
        const deheadingpeeling = new DeheadingPeelingEntity();
        deheadingpeeling.deheadingpeelingId = deheadingpeelingDTO.deheadingpeelingId;
        deheadingpeeling.scopeOfWork = deheadingpeelingDTO.scopeOfWork;
        deheadingpeeling.maxGrade = deheadingpeelingDTO.maxGrade;
        deheadingpeeling.minGrade = deheadingpeelingDTO.minGrade;
        deheadingpeeling.grade = deheadingpeelingDTO.grade;
        deheadingpeeling.ratePerKg = deheadingpeelingDTO.ratePerKg;
        deheadingpeeling.isActive=deheadingpeelingDTO.isActive==undefined?true:deheadingpeelingDTO.isActive;
        if (isUpdate) {
            deheadingpeeling.updatedUser = deheadingpeelingDTO.updatedUser;
        } else {
            deheadingpeeling.isActive = true;
            deheadingpeeling.createdUser =deheadingpeelingDTO.createdUser;
        }
        return deheadingpeeling;
        }
    public convertEntityToDto(deheadingpeelingObject:DeheadingPeelingEntity):DeheadingPeelingDTO{
        const deheadingpeelingDTO = new DeheadingPeelingDTO;
        deheadingpeelingDTO.deheadingpeelingId = deheadingpeelingObject.deheadingpeelingId;
        deheadingpeelingDTO.scopeOfWork = deheadingpeelingObject.scopeOfWork;
        deheadingpeelingDTO.grade = deheadingpeelingObject.grade;
        deheadingpeelingDTO.minGrade = deheadingpeelingObject.minGrade;
        deheadingpeelingDTO.maxGrade = deheadingpeelingObject.maxGrade;
        deheadingpeelingDTO.ratePerKg = deheadingpeelingObject.ratePerKg;
        deheadingpeelingDTO.isActive=deheadingpeelingObject.isActive;
        deheadingpeelingDTO.createdUser=deheadingpeelingObject.createdUser;
        deheadingpeelingDTO.updatedUser=deheadingpeelingObject.updatedUser;
        deheadingpeelingDTO.createdAt=deheadingpeelingObject.createdAt;
        deheadingpeelingDTO.updatedAt=deheadingpeelingObject.updatedAt;
        deheadingpeelingDTO.versionFlag=deheadingpeelingObject.versionFlag;

       return deheadingpeelingDTO;
    }
}